import React from 'react';
import { CommonInput, SelectInput } from '..';
import { formRequiredRules } from 'helper';
import { errorMessage } from 'constants/CommonConstants';
import { InputRadio } from 'sharedComponents/inputGroup/InputRadio';
import { Question, RenderQuestionParams, RenderQuestionsRecursivelyParams } from 'pages/tradeIn/TradeInInterface';

export const renderQuestion = ({ question, control, trigger, t, watch }: RenderQuestionParams) => {
  const watchField = watch(`questionIds-${question?.id}`);
  switch (question.type) {
    case 'radio':
      return (
        <InputRadio
          rules={question.required ? formRequiredRules(errorMessage(t).radioError) : {}}
          name={`questionIds-${question?.id}`}
          control={control}
          label={question?.label}
          options={question?.options}
          directionRow={true}
          triggerValidationForField={trigger}
        />
      );
    case 'input':
      return (
        <div className='vc-list__form-group mb-4'>
          <CommonInput
            rules={question.required ? formRequiredRules(errorMessage(t).required) : {}}
            name={`questionIds-${question?.id}`}
            control={control}
            label={question?.label}
            directionRow={true}
            triggerValidationForField={trigger}
          />
        </div>
      );
    case 'number':
      return (
        <div className='vc-list__form-group mb-4'>
          <CommonInput
            rules={question.required ? formRequiredRules(errorMessage(t).required) : {}}
            name={`questionIds-${question?.id}`}
            control={control}
            label={question?.label}
            directionRow={true}
            triggerValidationForField={trigger}
            type='number'
          />
        </div>
      );
    case 'select':
      return (
        <div className='mb-3'>
          <SelectInput
            rules={question.required ? formRequiredRules(errorMessage(t).required) : {}}
            name={`questionIds-${question?.id}`}
            control={control}
            label={question?.label}
            triggerValidationForField={trigger}
            options={question?.options}
            defaultValue={watchField}
          />
        </div>
      );
    default:
      return (
        <InputRadio
          rules={question.required ? formRequiredRules(errorMessage(t).radioError) : {}}
          name={`questionIds-${question?.id}`}
          control={control}
          label={question?.label}
          options={question?.options}
          directionRow={true}
          triggerValidationForField={trigger}
        />
      );
  }
};

export const renderQuestionsRecursively = ({
  questions,
  control,
  trigger,
  watchAllFields,
  t,
  watch,
}: RenderQuestionsRecursivelyParams) => {
  return questions.map((question: Question) => (
    <React.Fragment key={question.id}>
      {renderQuestion({ question, control, trigger, t, watch })}
      {watchAllFields[`questionIds-${question.id}`] &&
        question.conditionalQuestions &&
        question.conditionalQuestions[watchAllFields[`questionIds-${question.id}`]] &&
        renderQuestionsRecursively({
          questions: question.conditionalQuestions[watchAllFields[`questionIds-${question.id}`]],
          control,
          trigger,
          watchAllFields,
          t,
          watch,
        })}
    </React.Fragment>
  ));
};
